import { Injectable } from '@angular/core';
import { FieldStyle } from '../models/fieldstyle';

@Injectable()
export class HelperService {
    monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    copyArray(arr: any[]): any[] {
        return JSON.parse(JSON.stringify(arr));
    }

    copyObject(arr: any): any {
        if (!arr) {
            return undefined;
        }
        return JSON.parse(JSON.stringify(arr));
    }

    getMonthName(monthNo: any) {
        return this.monthNames[monthNo];
    }

    getHeaderStyle() {
        const obj = new FieldStyle();
        obj.fontSize = 12;
        obj.fontStyle = 'normal';
        obj.fontWeight = 'bold';
        obj.textAlign = 'center';
        obj.textOrientation = 'unset';
        return obj;
    }

    getGrandTotalStyle() {
        const obj = new FieldStyle();
        obj.fontSize = 12;
        obj.fontStyle = 'normal';
        obj.fontWeight = 'bold';
        obj.textAlign = 'left';
        obj.textOrientation = 'unset';
        return obj;
    }

    getCellStyle() {
        const obj = new FieldStyle();
        obj.fontSize = 12;
        obj.fontStyle = 'normal';
        obj.fontWeight = 'normal';
        obj.textAlign = 'left';
        obj.textOrientation = 'unset';
        return obj;
    }

    getStyleData() {
        const styledata: any = {};
        styledata['header'] = {
            fontSize: 14,
            bold: true,
            margin: [0, 0, 0, 10]
        };
        styledata['table'] = {
            margin: [0, 5, 0, 15]
        };
        styledata['tableCell'] = {
            bold: true,
            fontSize: 10,
            color: 'black'
        };
        styledata['titleValue'] = {
            fontSize: 10,
            color: 'black'
        };
        return styledata;
    }

    getPageInfo(pdfColCount: any) {
        let pageSize = 'A4';
        let pageOrientation = 'portrait';
        let pageWidth = 595;
        if (pdfColCount < 10) {
            pageOrientation = 'portrait';
            pageSize = 'A4';
            pageWidth = 595;
        } else if (pdfColCount < 15) {
            pageOrientation = 'landscape';
            pageSize = 'A4';
            pageWidth = 842;
        } else if (pdfColCount < 20) {
            pageOrientation = 'landscape';
            pageSize = 'A3';
            pageWidth = 1190;
        } else if (pdfColCount < 25) {
            pageOrientation = 'landscape';
            pageSize = 'A3';
            pageWidth = 1190;
        } else if (pdfColCount < 30) {
            pageOrientation = 'portrait';
            pageSize = 'A2';
            pageWidth = 1684;
        } else if (pdfColCount < 35) {
            pageOrientation = 'landscape';
            pageSize = 'A2';
            pageWidth = 1684;
        } else if (pdfColCount < 40) {
            pageOrientation = 'portrait';
            pageSize = 'A1';
            pageWidth = 2384;
        } else if (pdfColCount < 45) {
            pageOrientation = 'landscape';
            pageSize = 'A1';
            pageWidth = 2384;
        } else if (pdfColCount > 45) {
            pageOrientation = 'landscape';
            pageSize = 'A0';
            pageWidth = 3370;
        }

        return { 'pageOrientation': pageOrientation, 'pageSize': pageSize, 'pageWidth': pageWidth };
    }
}
